export default "__VITE_ASSET__BZxjzfW7__"